<div
  matSnackBarLabel
  class="snackbar-container"
>
  <div class="icon-container">
    @switch (data.type) {
      @case ('error') {
        <mat-icon class="icon icon-error">dangerous</mat-icon>
      }
      @case ('success') {
        <mat-icon class="icon icon-success">check_circle_outlined</mat-icon>
      }
      @case ('info') {
        <mat-icon class="icon icon-info">info</mat-icon>
      }
    }
  </div>
  <div class="message">
    {{ data.message }}
  </div>
</div>
<div
  matSnackBarActions
  class="btn-container"
>
  <button
    mat-button
    matSnackBarAction
    (click)="snackBarRef.dismissWithAction()"
  >
    Закрыть
  </button>
</div>
